import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";

export default class SwatchListPromptController {
  constructor(options, $state, $stateParams) {
    const $ctrl = this;
    basicController($ctrl);
    var model = ($ctrl.model = options.model);
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "List...";
    if (!model.list) {
      model.list = {
        name: "",
        listType: model.listType || options.listType || model.source.listType || "swatch"
      };
    }
  }

  save(close) {
    const $ctrl = this;
    var tempList = Object.assign({}, $ctrl.model.list);

    if ($ctrl.model.list.id) {
      $ctrl.bus
        .send("UpdateSwatchList.json?jsconfig=ua,uaa", tempList)
        .then(function (response) {
          $ctrl.$emit("swatchlistSaved", $ctrl);
          if (close) {
            $ctrl.$close($ctrl.model);
          }
        });
    } else {
      if ($ctrl.model.source) {
        $ctrl.bus
          .send(
            "DuplicateSwatchList.json?fromListId=" +
              $ctrl.model.source.id +
              "&jsconfig=ua,uaa",
            tempList
          )
          .then(function (response) {
            $ctrl.$emit("swatchlistSaved", $ctrl);
            $ctrl.model.list.id = response.data.id;
            $ctrl.$state.transitionTo("swatch.editlist", {
              listId: response.data.id,
            });
            if (close) {
              $ctrl.$close($ctrl.model);
            }
          });
      } else {
        $ctrl.bus
          .send("CreateSwatchList.json?jsconfig=ua,uaa", tempList)
          .then(function (response) {
            $ctrl.$emit("swatchlistSaved", $ctrl);
            $ctrl.model.list.id = response.data.id;
            $ctrl.$state.transitionTo("swatch.editlist", {
              listId: response.data.id,
            });
            if (close) {
              $ctrl.$close($ctrl.model);
            }
          });
      }
    }
  }

  submit() {
    const $ctrl = this;
    $ctrl.save(true);
  }

  delete() {
    const $ctrl = this;
    $ctrl.$close($ctrl.model);
    return modals
      .confirm("Are you sure?", "Delete List")
      .result.then(function () {
        $ctrl.bus
          .send("DeleteSwatchList.json", $ctrl.model.list)
          .then(function (response) {
            $ctrl.$emit("swatchlistDeleted", $ctrl);
            if ($ctrl.model.list.listType.toUpperCase() == "STOCK") {
              $ctrl.$state.transitionTo("swatch.stock-lists", {listType: $ctrl.model.list.listType});
            } else {
              $ctrl.$state.transitionTo("swatch.lists", {listType: $ctrl.model.list.listType});
            }
          });
      });
  }

  dismiss() {
    const $ctrl = this;
    //$ctrl.$emit('activitySaved', $ctrl);
    $ctrl.$dismiss();
  }
}
